/**
 * Deep copies a simple object with all its properties.
 * Does NOT work with methods and getters, this can only copy plain objects.
 */
export const deepCopy = <T>(something: T): T => JSON.parse(JSON.stringify(something))
